import FAPictureCardInformation from './FAPictureCardInformation'
export default FAPictureCardInformation
